import React from 'react';
import { transformNodeIdToPath } from '../../../utils/helpers';
import { useSelector } from 'react-redux';

export const BreadcrumbsSchema = ({ crumbs }) => {
  const context = useSelector((state) => state.app.context);

  const storeUrl = context.projectConfiguration['EXTENSION_PUBLIC_URL'];

  const getPath = ({ type, target }) => {
    if (type === 'node') {
      return transformNodeIdToPath(target);
    }
    return target;
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: crumb?.name,
      item: `${storeUrl}${
        crumb && crumb?.reference ? getPath(crumb?.reference) : ''
      }`,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
